import { ReactComponent as IconFilterActive } from "@/assets/svgs/cone-filter-active.svg";
import { ReactComponent as IconFilter } from "@/assets/svgs/cone-filter.svg";
import KeyboardEventHandler from '@infinium/react-keyboard-event-handler';
import classname from "classnames";
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { usePopper } from "react-popper";
import CaseOwnerDropdown from "./case-owner-dropdown.jsx";

const FilterDropDown = ({
	children,
	active,
	value,
	fromDate,
	endDate,
	setFromDate,
	setEndDate,
	setCaseOwner,
	caseOwner,
	tags,
	setTags,
}) => {
	const [visible, setVisible] = useState(false);

	const referenceRef = useRef(null);
	const popperRef = useRef(null);

	const { styles, attributes } = usePopper(
		referenceRef.current,
		popperRef.current,
		{
			placement: "bottom-end",
			modifiers: [
				{
					name: "offset",
					enabled: true,
					options: {
						offset: [0, 5],
					},
				},
			],
		}
	);

	const dropdownClass = classname({
		dropdown__content: true,
		"dropdown__content--active": visible,
		"cone-filter-dropdown__content": true,
	});

	async function handleDropdownClick(event) {
		setVisible(!visible);
	}

	function handleDocumentClick(event) {
		if (
			referenceRef.current.contains(event.target) ||
			popperRef.current.contains(event.target)
		) {
			return;
		}
		setVisible(false);
	}

	useEffect(() => {
		document.addEventListener("mousedown", handleDocumentClick);
		return () => {
			document.removeEventListener("mousedown", handleDocumentClick);
		};
	}, []);

	return (
		<div className="cone-filter" style={{ zIndex: 1 }}>
			<KeyboardEventHandler
				isExclusive={visible}
				handleKeys={["esc"]}
				onKeyEvent={(key, e) => {
					setVisible(false);
				}}
			/>
			<div
				className="icon"
				ref={referenceRef}
				onClick={handleDropdownClick}
				onKeyDown={handleDocumentClick}
			>
				{active ? <IconFilterActive /> : <IconFilter />}
			</div>
			<div ref={popperRef} style={styles.popper} {...attributes.popper}>
				<div className={dropdownClass}>
					<div className="input">
						<div className="label">Date Period</div>
						<div className="group">
							<ReactDatePicker
								dateFormat="d MMM yyyy"
								value={fromDate}
								selected={
									(fromDate && new Date(fromDate)) || null
								}
								todayButton="Today"
								dropdownMode="select"
								isClearable
								shouldCloseOnSelect
								showMonthDropdown
								showYearDropdown
								placeholderText="Start Date"
								onChange={(val) => {
									setFromDate(val);
								}}
							/>
							<span>-</span>
							<ReactDatePicker
								dateFormat="d MMM yyyy"
								value={endDate}
								selected={
									(endDate && new Date(endDate)) || null
								}
								todayButton="Today"
								dropdownMode="select"
								isClearable
								shouldCloseOnSelect
								showMonthDropdown
								showYearDropdown
								placeholderText="End Date"
								onChange={(val) => {
									val.setHours(23, 59, 59, 999);
									setEndDate(val);
								}}
							/>
						</div>
					</div>
					<div className="input">
						<div className="label">Package Owner</div>
						<div className="group">
							<CaseOwnerDropdown
								value={caseOwner}
								setValue={setCaseOwner}
							/>
						</div>
					</div>
					<div className="input">
						<div className="label">Package Tags</div>
						<div className="tags">
							{tags?.map((tag, index) => (
								<span
									key={index}
									onClick={(e) => {
										e.stopPropagation();
										setTags(
											tags.map((t) => {
												if (t.id === tag.id) {
													t.active = !t.active;
												}
												return t;
											})
										);
									}}
									className={classname({
										tag: true,
										"trim--two-lines": true,
										"tag--active": tag.active,
									})}
								>
									{tag?.name}
								</span>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

FilterDropDown.propTypes = {
	children: PropTypes.node,
	active: PropTypes.bool,
	value: PropTypes.string,
	fromDate: PropTypes.string,
	endDate: PropTypes.string,
	setFromDate: PropTypes.func,
	setEndDate: PropTypes.func,
	setCaseOwner: PropTypes.func,
	caseOwner: PropTypes.string,
	tags: PropTypes.array,
	setTags: PropTypes.func,
};

export default FilterDropDown;
